import template from './trip-item-flight-recommendation.html';
import tripEvents from '../../config/events.constant';
import {atcStates} from '../../../atc/atc-routes';

const DIRECTIVE_NAME = TripItemFlight.DIRECTIVE_NAME = 'ktTripItemFlightRecommendation';
export default function TripItemFlight() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripItemFlightRecommendationController,
        controllerAs: '$ctrl',
        scope: {
            flightRecommendation: `=${DIRECTIVE_NAME}`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
            getTooltip: `=${DIRECTIVE_NAME}GetTooltip`,
            cancelTrip: `=${DIRECTIVE_NAME}CancelTrip`,
            cancellation: `=${DIRECTIVE_NAME}Cancellation`,
            isCheckout: `=${DIRECTIVE_NAME}IsCheckout`,
            isCardFeeVisible: `=${DIRECTIVE_NAME}IsCardFeeVisible`,
            isUsRegion: `=${DIRECTIVE_NAME}IsUsRegion`,
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
            showAcceptDismissForBooker: `=${DIRECTIVE_NAME}ShowAcceptDismissForBooker`,
            lastReview: `=${DIRECTIVE_NAME}LastReview`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripItemFlightRecommendationController(
    $scope,
	$state,
    tripItemFlightRecommendationService,
    flightRecommendationService,
    flightFareService,
    l10nService,
    userService,
    tripUtils,
    tripItemService,
    selectedSeatsService,
    atcFlightsService,
    moment,
) {
    'ngInject';
    const vm = this;
    let isOneWayTrip;
    const TRIP_ITEM_FLIGHT = 'Flight';

    Object.assign(vm, {
        $onInit,
        isTrain,
        l10nService,
        getFlightAirportCodeRoute,
        isHoldUntilVisible,
        isDepartureHighlighted,
        isArrivalHighlighted,
        cancelTripItem,
        isItemNotIndicated,
        isTripItemIdApproved,
        isTripItemIdDeclined,
        isItemReviewed,
        applyReview,
        moment,
        findFlightStop: tripItemFlightRecommendationService.findFlightStop,
        generateRulesParameters: tripUtils.generateRulesParameters,
        hasUserSelectedSeatForFlightRecommendation: selectedSeatsService.hasUserSelectedSeatForFlightRecommendation,
        itemCannotBeCancelled: tripItemService.itemCannotBeCancelled,
		itemCanBeModified,
        modifyTripItem,
        validPnrValue,
    });

    function $onInit() {
        vm.isOfflineTrip = vm.tripDetails.IsOfflineTrip;
        vm.rs = userService.getRegionalSettings();
        vm.removeTitle = l10nService.localize('Remove');
        isOneWayTrip = tripItemFlightRecommendationService.isOneWayTrip(vm.flightRecommendation);
        vm.citiesRoute = tripItemFlightRecommendationService.getFlightRecommendationAirportCityRoute(vm.flightRecommendation)
            .join(' &rarr; ');
        vm.departureArrivalDates = tripItemFlightRecommendationService.getDepartureArrivalDates(vm.flightRecommendation);
        vm.flightFare = flightFareService.getFareTypeById(vm.flightRecommendation.FareType);
        vm.isCancelTooltipEnabled = tripItemService.itemCannotBeCancelled(vm.flightRecommendation, vm.tripDetails);
        vm.isNotCCUser = vm.tripDetails.ReviewTripInfo.CanBeCommented || vm.tripDetails.ReviewTripInfo.CanBeAccepted;
        vm.isSingleReviewer = vm.tripDetails.ReviewTripInfo.CanBeAccepted;
        vm.tripDetails.reviewModel = vm.tripDetails.reviewModel || {flights: {}, cars: {}, hotels: {}, rails: {}};
        vm.showItemReviewStatus = vm.lastReview && vm.lastReview.needToShowTripItems() && vm.showAcceptDismissForBooker();
    }

    function applyReview(flight, isAccepted) {
        vm.tripDetails.reviewModel.flights[flight.Id] = isAccepted;
    }

    function isItemReviewed(flightId) {
        return vm.tripDetails.reviewModel && vm.tripDetails.reviewModel.flights && vm.tripDetails.reviewModel.flights.hasOwnProperty(flightId);
    }

    function isTripItemIdDeclined(tripItemId) {
        return vm.showItemReviewStatus && vm.lastReview.getFirstUserReview().isTripItemIdDeclined(tripItemId);
    }

    function isTripItemIdApproved(tripItemId) {
        return vm.showItemReviewStatus && vm.lastReview.getFirstUserReview().isTripItemIdApproved(tripItemId);
    }

    function isItemNotIndicated(tripItemId) {
        return vm.showItemReviewStatus && vm.lastReview.getFirstUserReview().isTripItemIdNotInticated(tripItemId);
    }

    function isDepartureHighlighted(group) {
        if (isOneWayTrip) {
            return false;
        }

        const isOutwardGroup = tripItemFlightRecommendationService.isOutwardGroup(group, vm.flightRecommendation);
        const isInwardGroup = tripItemFlightRecommendationService.isInwardGroup(group, vm.flightRecommendation);

        if (isOutwardGroup) {
            return !tripItemFlightRecommendationService.isOutwardDepartEqualInwardArrival(group, vm.flightRecommendation, isOutwardGroup, isInwardGroup);
        } else if (isInwardGroup) {
            return !tripItemFlightRecommendationService.isInwardDepartEqualOutwardArrival(group, vm.flightRecommendation, isOutwardGroup, isInwardGroup);
        }

        return false;
    }

    function isArrivalHighlighted(group) {
        if (isOneWayTrip) {
            return false;
        }

        const isOutwardGroup = tripItemFlightRecommendationService.isOutwardGroup(group, vm.flightRecommendation);
        const isInwardGroup = tripItemFlightRecommendationService.isInwardGroup(group, vm.flightRecommendation);

        if (isOutwardGroup) {
            return !tripItemFlightRecommendationService.isInwardDepartEqualOutwardArrival(group, vm.flightRecommendation, isOutwardGroup, isInwardGroup);
        } else if (isInwardGroup) {
            return !tripItemFlightRecommendationService.isOutwardDepartEqualInwardArrival(group, vm.flightRecommendation, isOutwardGroup, isInwardGroup);
        }

        return false;
    }

    function isTrain() {
        return flightRecommendationService.isTrain(vm.flightRecommendation);
    }

    function getFlightAirportCodeRoute(flight) {
        return tripItemFlightRecommendationService.getFlightAirportCodeRoute(flight)
            .join(' &rarr; ');
    }

    function isHoldUntilVisible() {
        return tripItemFlightRecommendationService.isHoldUntilVisible(vm.flightRecommendation, vm.tripDetails);
    }

    function cancelTripItem(item) {
        const cancellationItem = {
            ...item,
            status: item.Status,
            id: item.Id,
            type: TRIP_ITEM_FLIGHT,
        };
        $scope.$emit(tripEvents.TRIP_CANCEL_ITEM, cancellationItem);
    }
    $scope.openFlightDates = function(flight) {
        $scope.$emit(tripEvents.EDIT_FLIGHT_DATES, flight);
        const openDates = document.getElementById('datesPanelFlight');
        openDates.classList.add('opened');
        const body = document.getElementById('body');
        body.classList.add('overlay');
    };

    function itemCanBeModified(tripItem, tripDetails) {
        return tripItem.ServiceOption.Name === 'AmadeusFlights'
            && !tripItemService.isTripItemCancelled(tripItem, tripDetails);
    }

    function modifyTripItem(tripDetails) {
        atcFlightsService.cleanCheckResultRequest();
        $state.go(atcStates.CHECK_RESULT, {
            pnr: tripDetails.PnrLocators[0],
            trip: tripDetails.Id,
            department: userService.getUser().Department,
            fromTripDetails: true,
        });
    }

    function validPnrValue() {
        // eslint-disable-next-line angular/window-service
        return vm.tripDetails.PnrLocators !== null
            && vm.tripDetails.PnrLocators.length > 0
            && vm.tripDetails.AreFlightsChangeable;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-recommendation/trip-item-flight-recommendation/trip-item-flight-recommendation-component.js